import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-reward-teaser',
  templateUrl: './reward-teaser.component.html',
  styleUrls: ['./reward-teaser.component.scss']
})
export class RewardTeaserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
